import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';

export function claimFormLoad(orderId, filters){
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms`;
  const method = 'GET'

  return {
    type: 'CLAIM_FORM_LOAD',
    payload: handleAPI(url,filters,method)
  };
}

export function claimFormLoadById(orderId, claimFormId, filters){
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms/${claimFormId}`;
  const method = 'GET'

  return {
    type: 'CLAIM_FORM_LOAD',
    payload: handleAPI(url,filters,method)
  };
}

export function claimFormCreate(orderId, filters = {}){
  const { orders_insurance_id, ...queryFilters } = filters;
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms`;
  const method = 'POST'
  const data = orders_insurance_id ? { orders_insurance_id } : null;

  return {
    type: 'CLAIM_FORM_CREATE',
    payload: handleAPI(url, queryFilters, method, data)
  };
}

export function claimFormUpdate(orderId, data, filters){
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms/${data.id}`;
  const method = "PUT"
  return {
    type: 'CLAIM_FORM_UPDATE',
    payload: handleAPI(url,filters,method, {insurance_claim_form: {...data}})
  }
}

export function claimFormSync(orderId, claimFormId, filters){
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms/${claimFormId}/sync`;
  const method = "GET"
  return {
    type: 'CLAIM_FORM_SYNC',
    payload: handleAPI(url,filters,method)
  }
}

export function claimFormSecureFax(orderId, claimFormId, filters){
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms/${claimFormId}/fax_pdf`;
  const method = 'GET'

  return {
    type: 'CLAIM_FORM_SECURE_FAX',
    payload: handleAPI(url,filters,method)
  };
}

export function trizettoSend(orderId, claimFormId, filters){
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms/${claimFormId}/send_to_trizzeto`;
  const method = 'GET'

  return {
    type: 'SEND_TO_TRIZETTO',
    payload: handleAPI(url,filters,method)
  };
}

export function claimFormDestroy(orderId, claimFormId) {
  const url = `/${API_VERSION_ONE}/orders/${orderId}/insurance_claim_forms/${claimFormId}`;
  const method = 'DELETE';

  return {
    type: 'CLAIM_FORM_DESTROY',
    payload: handleAPI(url, {}, method),
  };
}

export function claimFormReset() {
  return {
    type: 'CLAIM_FORM_RESET',
  };
}